export default __webpack_public_path__ + "static/media/dry-cleaning-round.9672bf3d.png";